import { render, staticRenderFns } from "./ImportantNotificationModal.vue?vue&type=template&id=3edc96fc&scoped=true&"
import script from "./ImportantNotificationModal.vue?vue&type=script&lang=js&"
export * from "./ImportantNotificationModal.vue?vue&type=script&lang=js&"
import style0 from "./ImportantNotificationModal.vue?vue&type=style&index=0&id=3edc96fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edc96fc",
  null
  
)

export default component.exports